module.exports = __webpack_public_path__ + "img/grass.d589dd00.svg";